import { render } from "./CommentStarButton.vue?vue&type=template&id=5676d259&scoped=true"
import script from "./CommentStarButton.vue?vue&type=script&lang=js"
export * from "./CommentStarButton.vue?vue&type=script&lang=js"

import "./CommentStarButton.vue?vue&type=style&index=0&id=5676d259&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5676d259"]])

export default __exports__